import type { AxiosRequestConfig } from 'axios'

import type { ID } from 'types/common'

import * as apiUtils from '.'

const url = '/user-landing'

// Get landing page data (favorites + recents)
export const getLandingData = (options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, options)

// Add site to favorites
export const addFavoriteSite = (siteId: ID) =>
  apiUtils.POST(`${url}/favorites/sites/${siteId}`, {})

// Remove site from favorites
export const removeFavoriteSite = (siteId: ID) =>
  apiUtils.DELETE(`${url}/favorites/sites/${siteId}`)

// Add project to favorites
export const addFavoriteProject = (projectId: ID) =>
  apiUtils.POST(`${url}/favorites/projects/${projectId}`, {})

// Remove project from favorites
export const removeFavoriteProject = (projectId: ID) =>
  apiUtils.DELETE(`${url}/favorites/projects/${projectId}`)

// Track site view (called automatically)
export const trackRecentSite = (siteId: ID) =>
  apiUtils.POST(`${url}/recents/sites/${siteId}`, {})

// Track project view (called automatically)
export const trackRecentProject = (projectId: ID) =>
  apiUtils.POST(`${url}/recents/projects/${projectId}`, {})

// Check if site is favorited
export const checkSiteFavorite = (
  siteId: ID,
  options: AxiosRequestConfig = {},
) => apiUtils.GET(`${url}/favorites/check/sites/${siteId}`, options)

// Check if project is favorited
export const checkProjectFavorite = (
  projectId: ID,
  options: AxiosRequestConfig = {},
) => apiUtils.GET(`${url}/favorites/check/projects/${projectId}`, options)
